import * as React from 'react';

import * as styles from './OfferMobile.css';
import { Label, UIHeading4, Body2 } from '@cian/ui-kit';
import { useInView } from '@cian/valuation-utils-component';

import { TOffer } from 'shared/types/offer';
import { Underground } from '../Underground';

interface IOfferMobileProps extends TOffer {
  onClick(id: number, position: number): void;
  position: number;
}

export const OfferMobile: React.FC<IOfferMobileProps> = ({
  imageUrl,
  price,
  features,
  href,
  geo: { undergrounds, regionId, address },
  labels,
  onClick,
  position,
  id,
}) => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (!id && inView) {
      // onShowTrap(analyticsData);
    }
  }, [inView, id]);

  return (
    <a
      ref={ref}
      onClick={() => onClick(id, position)}
      href={href}
      target="_blank"
      className={styles['container']}
      rel="noreferrer"
    >
      {imageUrl && <img src={imageUrl} className={styles['image']} />}
      <div className={styles['info']}>
        {labels.length ? (
          <span className={styles['label']}>
            <Label {...labels[0]} />
          </span>
        ) : null}
        <div className={styles['texts']}>
          <UIHeading4>{price}</UIHeading4>
          <Body2 whiteSpace="nowrap">{features}</Body2>
          {undergrounds[0] && <Underground small underground={undergrounds[0]} regionId={regionId} />}
          {(!undergrounds[0] || !labels.length) && (
            <span className={styles['address']}>
              <Body2 whiteSpace="nowrap">{address}</Body2>
            </span>
          )}
        </div>
      </div>
    </a>
  );
};
